import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ChevronRight, MapPin } from 'lucide-react';
import api from '../utils/api';

const SamadhanHomeWidget = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get('/samadhan/stats').then((r) => setStats(r.data)).catch(() => {}); }, []);
  // Countdown
  const [t, setT] = useState(() => Math.max(0, new Date('2031-01-01').getTime() - Date.now()));
  useEffect(() => { const id = setInterval(() => setT(Math.max(0, new Date('2031-01-01').getTime() - Date.now())), 1000); return () => clearInterval(id); }, []);
  const d = Math.floor(t / 86400000);
  const h = Math.floor((t % 86400000) / 3600000);
  const m = Math.floor((t % 3600000) / 60000);
  const s = Math.floor((t % 60000) / 1000);

  return (
    <section className="py-8 px-4" data-testid="samadhan-home-widget">
      <div className="max-w-7xl mx-auto">
        <style>{`@keyframes samadhan-blink-home { 0%,49%{opacity:1}50%,100%{opacity:.3} }`}</style>
        <div className="rounded-3xl border-2 border-amber-400/40 bg-gradient-to-br from-amber-900/25 via-fuchsia-900/25 to-emerald-900/25 p-6 lg:p-8 backdrop-blur-sm relative overflow-hidden">
          <div className="flex flex-wrap items-center gap-3 mb-3">
            <span className="text-red-300 font-extrabold text-xs tracking-widest" style={{ animation: 'samadhan-blink-home 1s infinite' }}>🚨 THE DREAM PROJECT 🚨</span>
            <span className="text-amber-300 font-extrabold text-xs tracking-widest" style={{ animation: 'samadhan-blink-home 1s infinite', animationDelay: '0.5s' }}>⏳ COMING SOON ⏳</span>
            <span className="text-xs px-2 py-1 bg-red-500/30 text-red-100 rounded-full font-semibold">LIVE FROM 01/01/2031</span>
          </div>
          <div className="flex items-start justify-between flex-wrap gap-3">
            <div className="flex-1 min-w-[240px]">
              <h2 className="text-3xl lg:text-5xl font-black bg-gradient-to-r from-amber-300 via-fuchsia-300 to-emerald-300 bg-clip-text text-transparent">SAMADHAN CENTER</h2>
              <div className="italic text-slate-200 text-sm md:text-base mt-1">Peace of mind, with the ultimate celebration of life.</div>
              <div className="text-[11px] text-slate-400 mt-1 flex items-center gap-2"><MapPin className="w-3 h-3" /> Paratwada, Maharashtra · Powered by Anant Web Portal</div>
            </div>
            <Link to="/samadhan" className="px-5 py-3 bg-gradient-to-r from-amber-500 to-fuchsia-500 text-white font-bold rounded-xl flex items-center gap-2 hover:scale-105 transition shadow-lg shadow-amber-500/30" data-testid="samadhan-home-cta">
              <Sparkles className="w-4 h-4" /> Explore & Donate <ChevronRight className="w-4 h-4" />
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-6">
            <StatCard label="Total Budget" val="50 Cr AT" sub="Community-funded" cls="from-amber-500/20 to-orange-500/20 border-amber-500/30" />
            <StatCard label="Reservoir Fund" val={stats ? `${Number(stats.reservoir_balance).toLocaleString('en-IN')} AT` : '—'} sub={stats ? `${stats.progress_pct}% raised` : ''} cls="from-emerald-500/20 to-teal-500/20 border-emerald-500/30" />
            <StatCard label="Donors" val={stats ? String(stats.unique_donors) : '—'} sub={stats ? `${stats.total_purchases} purchases` : ''} cls="from-fuchsia-500/20 to-pink-500/20 border-fuchsia-500/30" />
            <StatCard label="Grand Opening In" val={`${d}d ${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`} sub="Live 01/01/2031" cls="from-red-500/20 to-rose-500/20 border-red-500/30" mono />
          </div>

          <div className="mt-5 flex flex-wrap gap-2">
            {['🌿 Wellness & Healing', '🎉 Entertainment & Thrill', '🌴 Leisure & Lifestyle', '🎖️ Certificates', '💰 7-Tier Affiliate Network', '📸 Photo Gallery'].map((t) => (
              <span key={t} className="text-xs bg-slate-800/60 border border-slate-700 rounded-full px-3 py-1 text-slate-200">{t}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const StatCard = ({ label, val, sub, cls, mono }) => (
  <div className={`bg-gradient-to-br ${cls} border rounded-xl p-4`}>
    <div className="text-[10px] uppercase font-bold text-slate-300">{label}</div>
    <div className={`text-xl font-black text-white mt-1 ${mono ? 'font-mono' : ''}`}>{val}</div>
    {sub && <div className="text-[10px] text-slate-400 mt-0.5">{sub}</div>}
  </div>
);

export default SamadhanHomeWidget;
